export default __webpack_public_path__ + "static/media/bg6.c95ab81c.png";